<template>
    <v-list class="d-flex justify-center align-center" style="height: calc(100% - 64px)">
        <v-layout wrap column class="layout-add layout-add--max_width">
            <v-flex xs12 justify-center align-center class="d-flex loader">
                Пусто
            </v-flex>
        </v-layout>
    </v-list>
</template>

<script>
    export default {
        name: 'LoaderEmpty'
    }
</script>
